import styled from "styled-components";

// var tema = JSON.parse(localStorage.getItem("temaAtual"));

// if (tema === null) tema = { primaryColor: "#003da5" };

export const Button = styled.button`
  height: 45px;
  width: 100%;
  color: #ffffff;
  border: none;
  cursor: pointer;
  background-color: #d1d1d1;
  transition: 0.3s;
  font-size: 20px;
  font-weight: 900;
  text-transform: uppercase;
  margin-top: 25px;
  background-color: ${(props) =>
    props.bg != undefined ? props.bg : "#1D3054"};
  &:hover {
    box-shadow: 0px 0px 8px
      ${(props) => (props.bg != undefined ? props.bg : "#1D3054")};
  }
  &:disabled {
    &:hover {
      box-shadow: none;
    }
  }
`;
